/**
 * Name: Base de datos Académica del Colegio de la Frontera Sur
 * Description: Código hecho en react para la gestión y ordenamiento de los recursos electrónicos de ECOSUR.
 * Version: 3.2 - Para integración en WordPress/SIBE
 * Author: Marco Antonio Molina Espinosa
 * Fecha: 9 de febrero de 2026
 */

import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

const recursosIniciales = [
 
  { nombre: "Academia", 
    url: "https://www.academia.edu/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/academia.png", 
    resumen: "Es la plataforma libre, que funciona como red social académica, para compartir, recuperar y explorar artículos de investigación. Contiene más de 55 millones de documentos en acceso abierto relacionados con temas Multidisciplinarios.", 
    tipo: "Base de datos" },
  { nombre: "American Naturalist", 
    url: "https://www.journals.uchicago.edu/loi/an", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/American_Naturalist.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Annual Reviews", 
    url: "https://www.annualreviews.org/", 
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Annual_Reviews_logo.png", 
    resumen: "Colección de 48 revistas científicas de alto nivel, de las cuales 43 cuentan con Factor de impacto, lo que garantiza la calidad y relevancia de sus contenidos. Ofrece cobertura Multidisciplinaria en áreas como Biología, Biomedicina, Ciencias Exactas, Físicas y Ciencias Sociales. Tenemos acceso a los textos completos a partir de 2018.", 
    tipo: "Base de datos" 
  },
  { nombre: "Biblioteca digital mundial", 
    url: "https://www.loc.gov/collections/world-digital-library", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/bdm.png", 
    resumen: "Proyecto de la Biblioteca del Congreso de Estados Unidos de América. Es un recurso rico y valioso que muestra la diversidad de las culturas, incluye documentos históricos significativos, como libros, manuscritos, mapas, periódicos, revistas, grabaciones, fotografías, grabaciones sonoras y películas en sus idiomas originales. Historia, Cultura, Multidisciplinaria.", 
    tipo: "Base de datos" },
  { nombre: "Biblioteca Virtual en Salud", 
    url: "https://bvsalud.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/bvs.gif", 
    resumen: "Base de datos de la literatura científica y técnica en Salud con más de 1 millón de artículos de más de 900 títulos de revistas, tesis y disertaciones, libros y capítulos de libros, trabajos presentados en congresos, documentos gubernamentales y de organismo internacionales.", 
    tipo: "Base de datos" },
  { nombre: "Biodiversity Heritage Library", 
    url: "https://www.biodiversitylibrary.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/bhl.png", 
    resumen: "Portal de acceso abierto que contiene literatura antigüa y a texto completo sobre Biodiversidad. ", 
    tipo: "Base de datos" },
  { nombre: "BioMed Central", 
    url: "http://www.biomedcentral.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/BioMed-Central.gif", 
    resumen: "Con más de 300 revistas a texto completo y de acceso abierto relacionadas con las Ciencias de la Vida, las Ciencias de la Salud, la Medicina y las Ciencias Aplicadas,", 
    tipo: "Base de datos" },
  { nombre: "BioOne", 
    url: "https://bioone.org/browse/BioOneComplete", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_BIOONE.jpg", 
    resumen: "Biblioteca digital que contiene una colección de poco más de 200 revistas a texto completo enfocadas a las áreas de Biología, Ecología y Ciencias del Medio Ambiente. Las revistas son editadas por sociedades académicas y editores no comerciales. El período de acceso varía en cada título. Tenemos acceso al texto completo de todos los años de cada una de las revistas.", 
    tipo: "Base de datos" 
    
  },
  { nombre: "Bulletin of Marine Science", 
    url: "https://www.ingentaconnect.com/content/umrsmas/bullmar", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Bulletin_of_Marine_Science_(cover).jpg", 
    resumen: "", 
    tipo: "Revista" },
  
  { nombre: "Cambridge", 
    url: "https://www.cambridge.org/core", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Cambridge.png", 
    resumen: "Acceso al texto completo de una colección de más de 500 títulos de revistas científicas multidisciplinarias, revisadas por pares. La mayoría de revistas tienen un alto Factor de impacto. Los temas principales son: Humanidades, Ciencias Sociales, Ciencias, Tecnología y Medicina. El acceso a los textos completos es de 1997 en adelante.", 
    tipo: "Base de datos" 
  },
  { nombre: "Copit arXives", 
    url: "https://copitarxives.fisica.unam.mx/index.php", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/arxives.png", 
    resumen: "IIniciativa que edita libros electrónicos de acceso libre en los campos de la Ciencia, la Tecnología, la Sociedad y la Cultura. El contenido de este servicio está regulado por una licencia CopyLeft y es gestionado por un grupo de académicos procedentes principalmente de la Universidad Nacional Autónoma de México.", 
    tipo: "Base de datos" },
  { nombre: "Crustaceana", 
    url: "https://brill.com/view/journals/cr/cr-overview.xml", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/crustaceana.png", 
    resumen: "", 
    tipo: "Revista" },
  
  { nombre: "Dialnet", 
    url: "https://dialnet.unirioja.es/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/dialnet.png", 
    resumen: "Portal desarrollado por la Universidad de la Rioja, España, cuyo principal objetivo es dar mayor visibilidad a la literatura científica hispana. Es un proyecto de cooperación que integra distintos recursos y servicios documentales: artículos de revistas, documentos, tesis y ponencias en congresos en temas Multidisciplinarios.", 
    tipo: "Base de datos" },
  { nombre: "DOAJ (Directory of Open Access Journals)", 
    url: "https://doaj.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/doaj.jpeg", 
    resumen: "Es un directorio que ofrece el acceso al texto completo en acceso a bierto a más de 22, 000 revistas científicas de calidad, revisadas por pares, con contenidos Multidisciplinarios.", 
    tipo: "Base de datos" },
  { nombre: "Dynamed", 
    url: "https://search.ebscohost.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Ebsco%20Host.png", 
    resumen: "Herramienta de referencia clínica creada por médicos. Sirve de apoyo en la toma de decisiones clínicas relacionadas con las enfermedades, afecciones, hallazgos anormales, evaluaciones rutinarias y específicas, contenido hospitalario, análisis de riesgos, diagnósticos diferenciales, equidad en salud y gestión, dispositivos y procedimientos especializados. Temas principales: Medicina y Salud.", 
    tipo: "Base de datos" 
  },
  { nombre: "EBSCO Host", 
    url: "https://search.ebscohost.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Ebsco%20Host.png", 
    resumen: "Plataforma que contiene información de seis bases de datos: <strong>Academic Search Ultimate; Business Source Complete; eBook Collection; Fuente Académica; MedicLatina y Regional Business News.</strong> Ofrece textos completos en español e inglés de artículos científicos, notas de periódicos, conferencias, videos, libros e informes de temas multidisciplinarios, así como  información especializada en Negocios, Contabilidad, Finanzas y Medicina.",
    tipo: "Base de datos" 
  },
 
  { nombre: "Global Plants (JSTOR)", 
    url: "https://plants.jstor.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/JSTOR-jLogo.jpg", 
    resumen: "Base de datos que reúne millones de imágenes e información básica de especímenes vegetales y materiales primarios asociados (herbarios, documentos históricos, ilustraciones y fotografías). Es un recurso clave para la Botánica, la Ecología y la Conservación (Biología), al ofrecer imágenes de alta resolución y acceso a colecciones de todo el mundo que apoyan la investigación científica y la colaboración internacional.", 
    tipo: "Base de datos" 
  },
  { nombre: "Journal Citation Reports", 
    url: "https://jcr.clarivate.com/", 
    //logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/thomsonreuters.jpeg",
    logo:"https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Logo%20JCR.png",
    resumen: "Índices anuales publicados por la empresa Clarivate Analytics, que contiene el Factor de Impacto (Journal Impact Factor) de las revistas incluidas en dicho índice. Se publica a mediados de cada año y está integrado por 4 índices: Science Citation Index Expanded (SCIE), Social Science Citation Index (SSCI), Arts and Humanities Citation Index (AHCI) and Emerging Sources Citation Index (ESCI).", 
    tipo: "Base de datos" 
  },
  { nombre: "Journal of Applied Remote Sensing", 
    url: "https://www.spiedigitallibrary.org/journals/journal-of-applied-remote-sensing/issues", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/JournalofAppliedRemoteSensing.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "JSTOR", 
    url: "https://www.jstor.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/jstor-logo.png", 
    resumen: "Contiene un amplio número de revistas científicas de alta calidad que proporciona acceso a contenidos Multidisciplinarios, con énfasis en Ciencias de la Vida, Ciencias Naturales, Ciencias Sociales y Humanidades. Estas colecciones ofrecen acceso a años retrospectivos. Casi el total de revistas ofrecen los textos completos desde los primeros años.", 
    tipo: "Base de datos" 
  },
  { nombre: "Latindex", 
    url: "https://www.latindex.org/latindex/inicio", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_latindex.png", 
    resumen: "Plataforma que reúne y disemina información sobre revistas Multidisciplinarias. Cuenta con tres productos de información: 1. DIRECTORIO, ofrece datos bibliográficos y de contacto de todas las revistas impresas y en línea registradas, 2. CATÁLOGO 2.0, compuesto únicamente por revistas en línea que cumplen con los más altos estándares de calidad según la metodología de Latindex y 3. DESCUBRIDOR DE ARTÍCULOS, ofrece los artículos y documentos en texto completo publicados en las revistas que pertenecen al Catálogo 2.0.", 
    tipo: "Base de datos" },
 
  { nombre: "Microbiology and Molecular Biology Reviews", 
    url: "https://journals.asm.org/journal/mmbr", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Microbiology and Molecular Biology Reviews.jpeg", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature", 
    url: "https://www.nature.com/nature/current-issue", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/nature.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Biotechnology", 
    url: "https://www.nature.com/nbt/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Biotechnology.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Climate Change", 
    url: "https://www.nature.com/nclimate/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Climate_Change.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Ecology & Evolution", 
    url: "https://www.nature.com/natecolevol/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Ecology_&_Evolution.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Geoscience", 
    url: "https://www.nature.com/ngeo/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_geoscience.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Genetics", 
    url: "https://www.nature.com/nrg/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_genetics.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Materials", 
    url: "https://www.nature.com/nmat/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Materials.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Medicine", 
    url: "https://www.nature.com/nm/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Medicine.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Methods", 
    url: "https://www.nature.com/nmeth/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Methods.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Nanotechnology", 
    url: "https://www.nature.com/nnano/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Nanotechnology.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Photonics", 
    url: "https://www.nature.com/nphoton/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Photonics.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Physics", 
    url: "https://www.nature.com/nphys/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Physics.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Plants", 
    url: "https://www.nature.com/nplants/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Plants.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Protocols", 
    url: "https://www.nature.com/nprot/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Protocols.png", 
    resumen: "", 
    tipo: "Revista" },
  { nombre: "Nature Reviews Microbiology", 
    url: "https://www.nature.com/nrmicro/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Nature_Reviews_Microbiology.png", 
    resumen: "", 
    tipo: "Revista" }, 
  { nombre: "Open Access Theses and Dissertations (OATD)", 
    url: "https://oatd.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/oatd.png", 
    resumen: "Es una plataforma para encontrar tesis y disertaciones de posgrado de acceso abierto publicadas en todo el mundo. Los metadatos (información sobre las tesis) proceden de más de 1100 facultades, universidades e instituciones de investigación. Actualmente, OATD indexa 7 464 811 tesis y disertaciones de temas Multidisciplinarios.", 
    tipo: "Directorio" },
  { nombre: "Oxford Academic", 
    url: "https://academic.oup.com/journals/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_Oxford.png", 
    resumen: "Es la editorial que contiene una colección de aproximadamente 400 revistas de alta calidad e impacto respaldadas por la Universidad de Oxford, Reino Unido. Publica investigaciones y trabajos académicos importantes y rigurosos en áreas Multidisciplinarias, principalmente en Historia, Ciencias de la Vida y Economía. El acceso a los textos completos, generalmente es de 1996 en adelante.", 
    tipo: "Base de datos" 
  },
  { nombre: "PubMed", 
    url: "https://pubmed.ncbi.nlm.nih.gov/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/pubmed.png", 
    resumen: "Recurso gratuito que apoya la búsqueda y recuperación de información relacionada con la Biomedicina y Ciencias de la Vida. Contiene más de 39 millones de citas y resúmenes de literatura. No incluye artículos de revistas en texto completo, sin embargo, los enlaces al texto completo suelen estar presentes cuando están disponibles en otras fuentes.", 
    tipo: "Base de datos" },
  { nombre: "Quarterly Review of Biology", 
    url: "https://www.journals.uchicago.edu/loi/qrb", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/the-quarterly.gif", 
    resumen: "Revista que publica revisiones exhaustivas de investigación biológica.", 
    tipo: "Revista" },
  { nombre: "Redalyc",   
    url: "https://www.redalyc.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/redalyc.jpeg", 
    resumen: "La Red de Revistas Científicas de América Latina y el Caribe, España y Portugal, es un proyecto impulsado por la Universidad Autónoma de Estado de México (UAEM) para contribuir a la difusión de la actividad científica producida en Iberoamérica. Ofrece acceso libre al texto completo de revistas de alta calidad científica en temas Multidisciplinarios.", 
    tipo: "Base de datos" 
  },
  { nombre: "Repositorio CEPAL", 
    url: "https://repositorio.cepal.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/cepal.svg", 
    resumen: "El repositorio digital de la Comisión Económica para América Latina y el Caribe (CEPAL) reúne el conocimiento generado por esta Comisión desde 1948 hasta la actualidad. Integra documentos, recursos multimedia, autores y publicaciones clave sobre el Desarrollo Económico, Social y Ambiental de América Latina y el Caribe. Toda la información está disponible en acceso abierto.", 
    tipo: "Repositorio" },
  { nombre: "ResearchGate", 
    url: "https://www.researchgate.net/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/ResearchGate.svg", 
    resumen: "Plataforma académica y red social para personas dedicadas a la investigación científica. En ella se pueden encontrar artículos científicos, preprints, capítulos de libro, ponencias, conjuntos de datos y presentaciones, principalmente en áreas de Ciencia, Tecnología, Salud y Ciencias Sociales. Además, permite seguir a autores, proyectos y temas de investigación, facilitando la visibilidad de los trabajos y la colaboración académica.", 
    tipo: "Plataforma académica" },
  { nombre: "SAGE Journals", 
    url: "https://journals.sagepub.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_SAGE_Premier.gif", 
    resumen: "Conjunto de revistas académicas arbitradas que ofrece acceso a contenido de alta calidad en Ciencias Sociales, Humanidades y Ciencias de la Salud. Los títulos son líderes en áreas como Sociología, Educación, Psicología, Comunicación y Ciencias Políticas, entre otros. Constituye un recurso esencial para la investigación, la docencia y el análisis académico.", 
    tipo: "Base de datos" 
  },
  { nombre: "Science", 
    url: "https://science.sciencemag.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_Science.gif", 
    resumen: "Revista científica multidisciplinaria publicada por la American Association for the Advancement of Science.", 
    tipo: "Revista" },
  { nombre: "ScienceDirect", 
    url: "https://www.sciencedirect.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_ScienceDirect.png", 
    resumen: "Editorial que contiene el mayor número de publicaciones científicas a nivel mundial. Tenemos acceso al texto completo de poco más de 800 revistas Multidisciplinarias. La cobertura de los textos completos abarca de 2007 en adelante.", 
    tipo: "Base de datos" 
  },
  { nombre: "Scientific American", 
    url: "https://www.scientificamerican.com/archive/issues/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/1200px-Scientific_American_logo.svg_-1024x283.png", 
    resumen: "Revista de divulgación científica que presenta investigaciones y avances científicos para el público general.", 
    tipo: "Revista" },
  { nombre: "SciELO", 
    url: "https://www.scielo.org/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/scielo.jpeg", 
    resumen: "Biblioteca digital de acceso abierto que reúne revistas científicas de alta calidad, principalmente de América Latina, el Caribe, España y Portugal. Su enfoque está en la difusión de investigación revisada por pares, con especial énfasis en Ciencias de la Salud, Ciencias Sociales, Ciencias Naturales y Humanidades. En la plataforma se pueden consultar artículos científicos a textos completos en acceso abierto.", 
    tipo: "Directorio" },
  { nombre: "Scopus", 
    url: "https://www.scopus.com/home.uri", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/scopus-1.jpg", 
    resumen: "Plataforma, propiedad de Elsevier, que contiene millones de resúmenes y citas de revistas de las editoriales más prestigiosas del mundo con temáticas Multidisciplinarias. Su función es similar a Web of Science, de ofrecer datos y métricas de la producción científica a nivel mundial. Aquí podemos encontrar investigaciones relevantes -retrospectivas y actuales- e identificar a los expertos a nivel mundial y obtener información estratégica con las métricas y herramientas analíticas disponibles en la plataforma.", 
    tipo: "Base de datos" 
  },
  { nombre: "Springer", 
    url: "https://link.springer.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_Springer.jpg", 
    resumen: "Es una colección Multidisciplinaria de revistas científicas arbitradas que ofrece acceso a 1,910 títulos, de los cuales 1,451 cuentan con Factor de Impacto, además de 546 revistas en acceso abierto. Abarca áreas como Medicina, Ciencias de la Vida, Biomédicas, Ciencias Ambientales y de la Tierra, Matemáticas y Estadística, Química, entre otras. El acceso a los textos completos es de 1997 en adelante.", 
    tipo: "Base de datos" 
  },
  { nombre: "Taylor & Francis", 
    url: "https://www.tandfonline.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Taylor%20&%20Francis.svg", 
    resumen: "Editorial que contiene una colección Multidisciplinaria de cerca de 2,000 revistas científicas y académicas, de las cuales 1,907 cuentan con Factor de Impacto, organizada en dos grandes áreas: Ciencias Sociales y Humanidades, Ciencia y Tecnología. Incluye contenidos especializados en Artes, Educación, Negocios, Ingeniería, Computación, Ciencias Ambientales, Matemáticas y Física, entre otros. También ofrece 271 títulos en acceso abierto. El acceso a los textos completos es de 1997 en adelante.", 
    tipo: "Base de datos" 
  },
  { nombre: "The Education Resources Information Center (ERIC)", 
    url: "https://eric.ed.gov/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/eric.png", 
    resumen: "Base de datos bibliográfica y de texto completo relacionada con la investigación e información educativa. Esta herramienta es útil para estudiantes, investigadores y profesores. Ofrece información sobre cómo delimitar su tema, usar filtros de búsqueda y aprovechar el Tesauro de ERIC para encontrar recursos relacionados con temas de Educación.", 
    tipo: "Base de datos" 
  },
  { nombre: "Web of Science", 
    url: "https://www.webofscience.com/wos/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/Web_of_Science_Logo_12.2023.svg.png", 
    resumen: "Es la plataforma más importante para obtener información relacionada con la producción científica a nivel mundial por países, instituciones y autoras/es. También es una fuente importante para obtener información relevante de temas Multidisciplinarios ya que integra referencias de las revistas de mayor relevancia e impacto internacional. También contiene un número importante de referencias de libros. Los temas principales: Ciencias, Ciencias Sociales, Artes y Humanidades.", 
    tipo: "Base de datos" 
  },
  { nombre: "Wiley Online Library", 
    url: "https://onlinelibrary.wiley.com/", 
    logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/logo_Wiley_On_Line_Library.jpg", 
    resumen: "Plataforma que brinda el acceso a los textos completos de más de 1,300 revistas Multidisciplinarias publicadas por esta prestigiosa editorial. Casi todas las revistas tienen un alto Factor de impacto (Journal Impact Factor). El acceso a los textos completos, generalmente es de 1997 en adelante.", 
    tipo: "Base de datos" 
  },
  
  { nombre: "Zootaxa", 
    url: "https://mapress.com/zt/", 
    //logo: "https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/pageHeaderLogoImage_en_US-1024x74.png", 
    logo:"https://bibliotecasibe.ecosur.mx/sibe/wp-content/plugins/recursos-academicos-app/imagenes/imagen.png",
    resumen: "Revista internacional especializada en taxonomía zoológica.", 
    tipo: "Revista" }
];

const suscritas = [
  'Academic Search Ultimate',
  'Annual Reviews',
  'BioOne',
  'Business Source Complete',
  'Cambridge',
  'Dynamed',
  'EBSCO eBook Collection',
  'EBSCO Host',  
  'Fuente Académica',
  'Global Plants (JSTOR)',
  'Journal Citation Reports',
  'JSTOR',
  'Medic Latina',
  'Oxford Academic',
  'SAGE Journals',
  'Scopus',
  'ScienceDirect',
  'Springer',
  'Taylor & Francis',
  'Web of Science',
  'Wiley Online Library',
  'American Naturalist',
  'Bulletin of Marine Science',
  'Crustaceana',
  'Journal of Applied Remote Sensing',
  'Microbiology and Molecular Biology Reviews',
  'Nature',
  'Nature Biotechnology',
  'Nature Climate Change',
  'Nature Ecology & Evolution',
  'Nature Geoscience',
  'Nature Genetics',
  'Nature Materials',
  'Nature Medicine',
  'Nature Methods',
  'Nature Nanotechnology',
  'Nature Photonics',
  'Nature Physics',
  'Nature Plants',
  'Nature Protocols',
  'Nature Reviews Microbiology',
  'Quarterly Review of Biology',
  'Science',
  'Scientific American',
  'Zootaxa'
];

const recursos = recursosIniciales.map(r => ({
  ...r,
  acceso: suscritas.includes(r.nombre) ? 'suscrita' : 'libre',
  urlOriginal: r.url
}));

function App() {
  const [chkSuscritas, setChkSuscritas] = useState(false);
  const [chkLibres, setChkLibres] = useState(false);
  const [tipoRevista, setTipoRevista] = useState(false);
  const [tipoBaseDatos, setTipoBaseDatos] = useState(false);
  const [modoRapidoSwitch, setModoRapidoSwitch] = useState(true);
  const [letraActiva, setLetraActiva] = useState(null);
  const [resultados, setResultados] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [busquedaActiva, setBusquedaActiva] = useState('');
  const [sugerencias, setSugerencias] = useState([]);
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);

  // Función para verificar si hay filtros activos
  const hayFiltrosActivos = () => {
    return (
      chkSuscritas ||
      chkLibres ||
      tipoRevista ||
      tipoBaseDatos ||
      letraActiva !== null ||
      busquedaActiva.trim() !== ''
    );
  };

  // Función para transformar URLs al formato correcto del proxy ECOSUR
  const transformarUrlParaProxy = (urlOriginal) => {
    try {
      let url = urlOriginal;
  
      // Si no tiene protocolo, agregar https://
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
  
      // Construir URL del proxy SIN codificar
      const urlProxy = `https://login.ecosur.idm.oclc.org/login?url=${url}`;
  
      return urlProxy;
  
    } catch (error) {
      console.error('Error al transformar URL para proxy:', error);
      return urlOriginal;
    }
  };
  

  // FUNCIONALIDAD CLAVE: Aplicar proxy solo cuando es suscrita Y switch está activado (IDÉNTICO)
  const getEffectiveUrl = useCallback((recurso) => {
    if (recurso.acceso === 'suscrita') {
      if (modoRapidoSwitch) {
        return transformarUrlParaProxy(recurso.urlOriginal);
      } else {
        return recurso.urlOriginal; // acceso directo (red interna)
      }
    }
    return recurso.urlOriginal; // recursos libres siempre van directo
  }, [modoRapidoSwitch]);

  const letras = "ABCDEGJLMNOPQRSTWZ".split('');
  const letrasConRecursos = new Set(
    recursos.map(r => r.nombre.trim().charAt(0).toUpperCase()).filter(l => /[A-Z]/.test(l))
  );

  const buscarRecursos = (termino) => {
    if (!termino.trim()) return [];
    const terminoLower = termino.toLowerCase();
    return recursos.filter(r => 
      r.nombre.toLowerCase().includes(terminoLower) ||
      r.tipo.toLowerCase().includes(terminoLower) ||
      (r.resumen && r.resumen.toLowerCase().includes(terminoLower))
    );
  };

  const handleBusquedaChange = (e) => {
    const valor = e.target.value;
    setBusqueda(valor);
    if (valor.trim()) {
      setSugerencias(buscarRecursos(valor));
      setMostrarSugerencias(true);
    } else {
      setSugerencias([]);
      setMostrarSugerencias(false);
    }
  };

  const handleBuscar = () => {
    if (busqueda.trim()) {
      setBusquedaActiva(busqueda);
      setLetraActiva(null);
    } else {
      setBusquedaActiva('');
    }
    setMostrarSugerencias(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleBuscar();
  };

  const handleSeleccionarSugerencia = (recurso) => {
    setBusqueda(recurso.nombre);
    setBusquedaActiva(recurso.nombre);
    setSugerencias([]);
    setMostrarSugerencias(false);
    setLetraActiva(null);
  };

  const renderResultados = useCallback(() => {
    let resultadosFiltrados = recursos;
    if (letraActiva) {
      resultadosFiltrados = resultadosFiltrados.filter(r => 
        r.nombre.trim().toUpperCase().startsWith(letraActiva)
      );
    }
    if (busquedaActiva.trim()) {
      const terminoLower = busquedaActiva.toLowerCase();
      resultadosFiltrados = resultadosFiltrados.filter(r => 
        r.nombre.toLowerCase().includes(terminoLower) ||
        r.tipo.toLowerCase().includes(terminoLower) ||
        (r.resumen && r.resumen.toLowerCase().includes(terminoLower))
      );
    }
    if (chkSuscritas || chkLibres) {
      resultadosFiltrados = resultadosFiltrados.filter(r => {
        return (chkSuscritas && r.acceso === 'suscrita') || (chkLibres && r.acceso === 'libre');
      });
    }
    const tiposSel = [];
    if (tipoRevista) tiposSel.push('Revista');
    if (tipoBaseDatos) tiposSel.push('Base de datos');
    if (tiposSel.length > 0) {
      resultadosFiltrados = resultadosFiltrados.filter(r => tiposSel.includes(r.tipo));
    }
    setResultados(resultadosFiltrados);
  }, [letraActiva, chkSuscritas, chkLibres, tipoRevista, tipoBaseDatos, busquedaActiva]);

  useEffect(() => {
    renderResultados();
  }, [renderResultados]);

  const handleLetraClick = (letra) => {
    setLetraActiva(letra === null ? null : letra);
    setBusquedaActiva('');
    setBusqueda('');
    setSugerencias([]);
    setMostrarSugerencias(false);
  };

  const handleResetFilters = () => {
    setChkSuscritas(false);
    setChkLibres(false);
    setTipoRevista(false);
    setTipoBaseDatos(false);
    setLetraActiva(null);
    setBusqueda('');
    setBusquedaActiva('');
    setSugerencias([]);
    setMostrarSugerencias(false);
    setExpandedIndex(null);
  };

  const handleLimpiarBusqueda = () => {
    setBusqueda('');
    setBusquedaActiva('');
    setSugerencias([]);
    setMostrarSugerencias(false);
  };

  const handleImageError = (e) => {
 //   e.target.onerror = null;
 //   e.target.src = `https://via.placeholder.com/50x50/cccccc/666666?text=${e.target.alt.charAt(0)}`; *
  };

  const handleSummaryClick = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const isTextShort = (text) => text && text.length <= 100;

  // Función para verificar si un recurso tiene resumen (no está vacío)
  const tieneResumen = (resumen) => {
    return resumen && resumen.trim() !== '';
  };

  // Función para renderizar el resumen con HTML
  const renderResumen = (resumen, isExpanded, isShort, tieneResumen) => {
    if (!tieneResumen) return null;
    
    if (isExpanded || isShort) {
      return <span dangerouslySetInnerHTML={{ __html: resumen }} />;
    } else {
      return <span dangerouslySetInnerHTML={{ __html: resumen.substring(0, 100) + '...' }} />;
    }
  };

  return (
    <div className="sibe-react-app">
      <div className="sibe-container">
        <aside className="sibe-filters">
          <div className="sibe-buscador-container">
            <div className="sibe-buscador-wrapper">
              <div className="sibe-input-group">
                <input
                  type="text"
                  className="sibe-buscador-input"
                  placeholder="Busca por nombre o contenido..."
                  value={busqueda}
                  onChange={handleBusquedaChange}
                  onKeyPress={handleKeyPress}
                  onFocus={() => busqueda.trim() && setMostrarSugerencias(true)}
                  onBlur={() => setTimeout(() => setMostrarSugerencias(false), 200)}
                />
                {busqueda && (
                  <button 
                    className="sibe-btn-limpiar"
                    onClick={handleLimpiarBusqueda}
                    aria-label="Limpiar búsqueda"
                  >
                    ×
                  </button>
                )}
                <button 
                  className="sibe-btn-buscar"
                  onClick={handleBuscar}
                  aria-label="Buscar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                  </svg>
                </button>
              </div>
              {mostrarSugerencias && sugerencias.length > 0 && (
                <div className="sibe-sugerencias-container">
                  <div className="sibe-sugerencias-list">
                    {sugerencias.slice(0, 5).map((recurso, index) => (
                      <div
                        key={`sugerencia-${index}`}
                        className="sibe-sugerencia-item"
                        onClick={() => handleSeleccionarSugerencia(recurso)}
                      >
                        <div className="sibe-sugerencia-logo">
                          <img 
                            src={recurso.logo} 
                            alt={`Logo ${recurso.nombre}`}
                            onError={handleImageError}
                          />
                        </div>
                        <div className="sibe-sugerencia-info">
                          <div className="sibe-sugerencia-nombre">{recurso.nombre}</div>
                          <div className="sibe-sugerencia-tipo">{recurso.tipo}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="sibe-buscador-stats">
              {busquedaActiva ? (
                <span>
                  {resultados.length === 1 
                    ? `1 resultado para "${busquedaActiva}"` 
                    : `${resultados.length} resultados para "${busquedaActiva}"`}
                </span>
              ) : letraActiva ? (
                <span>
                  {resultados.length === 1 
                    ? `1 recurso que empieza con "${letraActiva}"` 
                    : `${resultados.length} recursos que empiezan con "${letraActiva}"`}
                </span>
              ) : (
                <span>{recursos.length} recursos disponibles</span>
              )}
            </div>
          </div>
          <div className="sibe-filter-section">
            <h3>Tipo de contenido</h3>
            <ul>
              <li>
                <label>
                  <input 
                    type="checkbox" 
                    checked={chkSuscritas}
                    onChange={(e) => setChkSuscritas(e.target.checked)}
                  /> 
                  Suscritas
                </label>
              </li>
              <li>
                <label>
                  <input 
                    type="checkbox" 
                    checked={chkLibres}
                    onChange={(e) => setChkLibres(e.target.checked)}
                  /> 
                  Libres
                </label>
              </li>
            </ul>
          </div>
          <div className="sibe-filter-section">
            <h3>Tipo de recurso</h3>
            <ul>
              <li>
                <label>
                  <input 
                    type="checkbox" 
                    checked={tipoRevista}
                    onChange={(e) => setTipoRevista(e.target.checked)}
                  /> 
                  Revista
                </label>
              </li>
              <li>
                <label>
                  <input 
                    type="checkbox" 
                    checked={tipoBaseDatos}
                    onChange={(e) => setTipoBaseDatos(e.target.checked)}
                  /> 
                  Base de datos
                </label>
              </li>
            </ul>
          </div>
          <div className="sibe-switch-section">
            <h3>Acceso remoto</h3>
            <div className="sibe-switch-container">
              <label className="sibe-switch">
                <input 
                  type="checkbox" 
                  checked={modoRapidoSwitch}
                  onChange={(e) => setModoRapidoSwitch(e.target.checked)}
                />
                <span className="sibe-slider"></span>
              </label>
              <span className="sibe-switch-label">
                {modoRapidoSwitch ? 'Activado' : 'Desactivado'}
              </span>
            </div>
            <div className="sibe-switch-description">
              {modoRapidoSwitch 
                ? 'Acceso a recursos suscritos desde fuera de ECOSUR' 
                : 'Acceso directo a recursos (recomendado dentro de ECOSUR)'}
            </div>
          </div>
          
          {/* Botón Reiniciar filtros - solo se muestra cuando hay filtros activos */}
          {hayFiltrosActivos() && (
            <div className="sibe-btn-group">
              <button className="sibe-btn sibe-btn-reset" onClick={handleResetFilters}>
                Reiniciar filtros
              </button>
            </div>
          )}
        </aside>
        <main className="sibe-results">
          <div className="sibe-video-container">
            <h3>Tutorial de uso</h3>
            <div className="sibe-youtube-video">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/VJkmaJijncs" /*agregar solo la lcave del video para modificar (7qNUH0pDNJw)*/
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="sibe-alphabet-filter">
            {letras.map((letra) => {
              const isDisabled = !letrasConRecursos.has(letra);
              return (
                <button
                  key={letra}
                  className={letraActiva === letra ? 'sibe-active' : ''}
                  disabled={isDisabled}
                  onClick={() => !isDisabled && handleLetraClick(letra)}
                >
                  {letra}
                </button>
              );
            })}
            <button
              className={!letraActiva && !busquedaActiva ? 'sibe-active' : ''}
              onClick={() => handleLetraClick(null)}
            >
              Todos
            </button>
          </div>
          <div className="sibe-results-content">
            {resultados.length === 0 ? (
              <div className="sibe-no-results">
                {busquedaActiva 
                  ? `No se encontraron resultados para "${busquedaActiva}"`
                  : letraActiva
                  ? `No se encontraron recursos que empiecen con "${letraActiva}"`
                  : "No se encontraron recursos que coincidan con los filtros seleccionados."}
                <br />
                <button 
                  className="sibe-btn sibe-btn-busqueda" 
                  onClick={handleResetFilters}
                >
                  Mostrar todos los recursos
                </button>
              </div>
            ) : (
              resultados.map((r, index) => {
                const recursoTieneResumen = tieneResumen(r.resumen);
                const isExpanded = expandedIndex === index;
                const isShort = isTextShort(r.resumen);
                
                return (
                  <div 
                    className="sibe-resource-item" 
                    key={`${r.nombre}-${index}`}
                  >
                    <div className="sibe-resource-logo">
                      <img 
                        src={r.logo} 
                        alt={`Logo ${r.nombre}`}
                        onError={handleImageError}
                      />
                    </div>
                    <div className="sibe-resource-info">
                      <h3>
                        <a 
                          href={getEffectiveUrl(r)} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="sibe-resource-link"
                        >
                          {r.nombre}
                        </a>
                        <span className={`sibe-badge sibe-${r.acceso}`}>
                          {r.acceso === 'suscrita' ? 'Suscrita' : 'Libre'}
                        </span>
                      </h3>
                      
                      {/* Solo mostrar el contenedor del resumen si el recurso tiene resumen */}
                      {recursoTieneResumen && (
                        <div 
                          className={`sibe-summary-container ${isExpanded ? 'sibe-expanded' : ''} ${isShort ? 'sibe-short-text' : ''}`}
                          onClick={() => handleSummaryClick(index)}
                          style={{ cursor: isShort ? 'default' : 'pointer' }}
                        >
                          <p className="sibe-summary">
                            {renderResumen(r.resumen, isExpanded, isShort, recursoTieneResumen)}
                            {!isShort && !isExpanded && recursoTieneResumen && (
                              <span className="sibe-read-more"> [clic para ver más]</span>
                            )}
                            {!isShort && isExpanded && recursoTieneResumen && (
                              <span className="sibe-read-less"> [clic para contraer]</span>
                            )}
                          </p>
                        </div>
                      )}
                      
                      <div className="sibe-resource-meta">
                        <span className="sibe-resource-tipo">{r.tipo}</span>
                        <span className="sibe-resource-url">
                          {r.acceso === 'suscrita' && modoRapidoSwitch 
                            ? 'Acceso remoto' 
                            : 'Acceso directo'}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;